/**
 * 5 passos da parceria — sóbrios, numerados, sem ícones decorativos.
 */

const STEPS = [
  {
    n: "01",
    title: "Participe da Live",
    description: "Entenda a operação e tire suas dúvidas",
  },
  {
    n: "02",
    title: "Faça sua aplicação",
    description: "Se cadastre na plataforma de parceiros",
  },
  {
    n: "03",
    title: "Aguarde aprovação",
    description:
      "Selecionamos somente os assessores que mais fazem sentido",
  },
  {
    n: "04",
    title: "Receba treinamento e materiais",
    description: "Tenha apoio total da nossa equipe",
  },
  {
    n: "05",
    title: "Divulgue os produtos Allu Invest e gere receita",
  },
];

export const SelecaoComoFunciona = () => {
  return (
    <section id="como-funciona" className="bg-[#FAF8F5] scroll-mt-24">
      <div className="container-wide py-16 sm:py-24">
        <div className="max-w-3xl mb-8 sm:mb-10">
          <div className="text-[11px] font-semibold tracking-[0.14em] uppercase text-zinc-500">
            Como funciona a parceria
          </div>
        </div>

        <ol className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6 sm:gap-5 lg:gap-6">
          {STEPS.map((s, i) => (
            <li
              key={i}
              className="border-l-2 lg:border-l-0 lg:border-t-2 border-[#112711]/15 pl-5 lg:pl-0 lg:pt-5"
            >
              <div className="text-xs font-semibold tracking-[0.14em] text-zinc-500 tabular-nums">
                {s.n}
              </div>
              <div className="mt-2 text-base sm:text-lg font-semibold text-[#112711] tracking-tight leading-snug">
                {s.title}
              </div>
              {s.description && (
                <div className="mt-1.5 text-sm text-zinc-600 leading-relaxed">
                  {s.description}
                </div>
              )}
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
};
